import React from "react";
import PropTypes from "prop-types";
import { renderToString } from "react-dom/server";
import { spring, StaggeredMotion } from "react-motion";

import {
  Image,
  SharingPopup,
  StorageHandler,
  DataHandler,
  APIHandler,
} from "C4";
import { storageKeys } from "settings";

const trackShare = (type, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = "Guest";
      if (userObj && userObj) {
        ({ email } = userObj);
      }
      APIHandler.trackEvent(appId, email, "collateral", type, value).then(
        () => {}
      );
    });
  });
};

const VideoCollection = (props) => {
  const { chapter } = props;
  const chapterName = chapter[0].chapter.chapterTitle;
  const chapterNr = chapter[0].chapter.chapterNumber;

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(chapter).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = (url, image, title) => ({
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: "x",
    },
    baseClass: "customBox",
    buttons: ["thumbs", "close"],
    // share: {
    //   tpl: renderToString(<SharingPopup url={url} image={image} title={title} />),
    // },
    caption: title,
  });

  return (
    <div className="videoGrid__Container">
      <div className="videoGrid__Container--title">
        <h3>{chapterName}</h3>
        {chapter.chapterNumber < 100 && (
          <h5>{`Chapter ${chapter.chapterNumber}`}</h5>
        )}
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={(prevInterpolatedStyles) =>
          prevInterpolatedStyles.map((_, i) =>
            i === 0
              ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
              : {
                  pos: spring(prevInterpolatedStyles[i - 1].pos, {
                    stiffness: 320,
                    damping: 28,
                  }),
                }
          )
        }
      >
        {(styles) => (
          <div className="videoGrid__Grid">
            {Object.values(chapter).map((item, index) => {
              const { linkJW, thumbnail, title, url } = item;
              return (
                <div className="videoGrid_Holder">
                  <div
                    className="videoGrid_Card"
                    key={linkJW}
                    href={url}
                    style={{ opacity: `${styles[index].pos}` }}
                    data-fancybox={url}
                    data-options={JSON.stringify(
                      fancyOptions(url, thumbnail, title)
                    )}
                    data-caption={title}
                    onClick={() => trackShare("collectionItem", url)}
                  >
                    <Image
                      key={linkJW}
                      src={
                        thumbnail ||
                        "https://via.placeholder.com/350x250?text=Placeholder%20Thumbnail"
                      }
                      gradient
                      onLoad={() => {
                        this.setState({ loading: false });
                      }}
                      href={url}
                    />
                  </div>
                  <div className="title">{title}</div>
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default VideoCollection;

VideoCollection.propTypes = {
  chapter: PropTypes.arrayOf.isRequired,
};
